/* eslint-disable jira/filename-case */
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';

export const CONNECT_ROUTES_SET: Set<RouteName> = new Set<RouteName>([
	'connect-project',
	'connect-general',
	'connect-general-service-desk-project',
	'legacy-connect-project',
	'legacy-connect-general',
]);

export const JSM_BOARD_ROUTES_SET: Set<RouteName> = new Set<RouteName>([
	'servicedesk-boards',
	'servicedesk-queues-views-config',
	'servicedesk-practice-views-config',
]);
